
import React from "react";
import { Button } from "@/components/ui/button";
import { PlayCircle, Trash2 } from "lucide-react";

interface VideoItemProps {
  video: {
    id: string;
    url: string;
    title: string;
    createdAt: string;
  };
  onDelete: (videoId: string, filePath: string) => Promise<void>;
  onAnalyze: (video: {
    id: string;
    url: string;
    title: string;
    createdAt: string;
  }) => void;
  getFilenameFromUrl: (url: string) => string;
}

const VideoGridItem: React.FC<VideoItemProps> = ({
  video,
  onDelete,
  onAnalyze,
  getFilenameFromUrl,
}) => {
  return (
    <div className="border rounded-lg overflow-hidden flex flex-col">
      <div className="relative aspect-video">
        <video
          src={video.url}
          className="w-full h-full object-cover"
        />
        <Button
          variant="ghost"
          size="icon"
          className="absolute inset-0 m-auto bg-black/30 rounded-full w-12 h-12 hover:bg-black/50"
          onClick={() => onAnalyze(video)}
        >
          <PlayCircle className="h-8 w-8 text-white" />
        </Button>
      </div>
      <div className="p-3 flex justify-between items-center">
        <div className="truncate">
          <p className="font-medium truncate">{video.title}</p>
          <p className="text-xs text-gray-500">
            {new Date(video.createdAt).toLocaleDateString()}
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="text-red-500 hover:text-red-700 hover:bg-red-50"
          onClick={() => onDelete(video.id, getFilenameFromUrl(video.url))}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default VideoGridItem;
